export class LookupEnvironmentResponse {
	constructor(
		public authWebURL: string,
		public enhWebURL: string,
		public versionNumber: string,
		public disabledFeatures: Array<string>
	) {
		if (null === disabledFeatures) {
			this.disabledFeatures = new Array<string>();
		}
	}
}
